import { defineDashboardTranslations } from "./translationTypes";

/** Labels for the shared ExpandableImage thumbnail, preview dialog and its action. */
export const translationExpandableImage = defineDashboardTranslations({
  da: {
    expandableImageExpand: "Forstør billede: {name}",
    expandableImageFallbackName: "vedhæftet billede",
    expandableImageDialogTitle: "Forhåndsvisning af billede",
    expandableImageDownload: "Download",
    expandableImageOpen: "Åbn i ny fane",
  },
  en: {
    expandableImageExpand: "Expand image: {name}",
    expandableImageFallbackName: "attached image",
    expandableImageDialogTitle: "Image preview",
    expandableImageDownload: "Download",
    expandableImageOpen: "Open in new tab",
  },
  sv: {
    expandableImageExpand: "Förstora bild: {name}",
    expandableImageFallbackName: "bifogad bild",
    expandableImageDialogTitle: "Bildförhandsvisning",
    expandableImageDownload: "Ladda ned",
    expandableImageOpen: "Öppna i ny flik",
  },
});
